import React, { createContext, useContext, useState, useEffect } from 'react';

const HelpTooltipContext = createContext({});

export const HelpTooltipProvider = ({ children }) => {
  const [tooltips, setTooltips] = useState({});

  useEffect(() => {
    fetch('/content/tooltips.json')
      .then(r => (r.ok ? r.json() : null))
      .then(data => { if (data?.tooltips) setTooltips(data.tooltips); })
      .catch(() => {}); // tooltips are optional — fail silently
  }, []);

  return (
    <HelpTooltipContext.Provider value={tooltips}>
      {children}
    </HelpTooltipContext.Provider>
  );
};

export const useTooltips = () => useContext(HelpTooltipContext);
